/**
 * The AdvertiseCardSlider component is a React component that displays a slider of advertisement
 * cards, with the number of cards displayed per slide depending on the screen size.
 * @returns The AdvertiseCardSlider component is being returned.
 */
import React, { useState, useLayoutEffect } from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper.min.css";
import "./advertiseCardSlider.css";
import { useSelector } from "react-redux";

const AdvertiseCardSlider = () => {

 const ads = useSelector((state) => state.ads)
  const [isMobile, setIsMobile] = useState(false);

  useLayoutEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);

    handleResize(); // Call handleResize on initial render
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
    {ads.length > 0 &&
    <div className="container advertiseCardSlider pt-1 ">
      <Swiper spaceBetween={50} slidesPerView={isMobile ? 1.5 : 3.4}>
        {ads.map((ad) => (
          <SwiperSlide key={ad.advertisement_id} style={{ marginRight: "10px" }}>
            {/* <Link to="/shop" type="button"> */}
              <div>
              <img style={{ borderRadius: "8px"}} src={ad.src} width={"346"} height={isMobile ? "150":"201"} alt={`slide-${ad.advertisement_id}`} />
              </div>
            {/* </Link> */}
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
    }
    </>
  );
};

export default AdvertiseCardSlider;
